import { useState } from "react";

import { useApiWithAbort } from "Services/AbstractApiService";
import { autocompleteOptions } from "Services/Autocomplete/AutocompleteService";

import type { NullOr } from "@regal-voice/shared-types";

type AutocompleteQueryPayload = {
    fieldId: string;
};
export const useAutocompleteQuery = ({ fieldId }: AutocompleteQueryPayload) => {
    const [queryPayload] = useState<{
        searchTerm: string;
        lastEvaluatedKey: NullOr<{ id: string; info: string }>;
    }>({ searchTerm: "", lastEvaluatedKey: null });

    const [dropDownOptions] = useApiWithAbort<typeof autocompleteOptions>(autocompleteOptions, {
        searchTerm: queryPayload.searchTerm,
        lastEvaluatedKey: queryPayload.lastEvaluatedKey,
        limit: 30,
        fieldId: fieldId,
    });

    return { dropDownOptions };
};
